import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

const NavigationGuard = ({ children }) => {
  const { isAuthenticated, isLoading } = useSelector((state) => state.auth);
  const navigate = useNavigate();
  const location = useLocation();

  // List of protected routes
  const protectedRoutes = ['/dashboard', '/profile'];
  const isProtectedRoute = protectedRoutes.includes(location.pathname);

  useEffect(() => {
    // If trying to access protected route without authentication
    if (isProtectedRoute && !isLoading && !isAuthenticated) {
      navigate('/login', { replace: true });
    }
    
    // If authenticated user tries to access login page, redirect to dashboard
    if (location.pathname === '/login' && isAuthenticated) {
      navigate('/dashboard', { replace: true });
    }
  }, [isAuthenticated, isLoading, isProtectedRoute, navigate, location.pathname]);

  return children;
};

export default NavigationGuard;
